import { render } from "./student-tickets.vue?vue&type=template&id=35b46340"
import script from "./student-tickets.vue?vue&type=script&lang=js"
export * from "./student-tickets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__